





















import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import Global from '@/common/global.js'
import store from '@/store'
import Pager from '@/views/organisms/Pager.vue'

export default
  components: {
    ApiClient
    BlueButton
    Pager
  }

  data: () ->
    members: []
    level: Global.level()
    page: {}
    page_number: '1'

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    @get_tanto()

  methods: {
    click_new: (e) ->
      @$router.push 'tanto_edit'
    showLevel: (v) ->
      for row, index in @level
        if row.id == Number(v)
          return row.name
    tanto_delete: (id) ->
      param =
        id: id
      api = new ApiClient()
      data = await api.post('/fc/tanto/delete', param)
      if data.errors.length == 0
        @get_tanto()
    get_tanto: () ->
      api = new ApiClient()
      data = await api.get('/fc/tanto/list/' + @page_number)
      @members = data.list
      @page = data.page
    detail_click: (id) ->
      @$router.push '/tanto_edit/detail/' + id
    move_page: (page) ->
      @page_number = page
      @get_tanto()
  }
